// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bhc_a","AdSlotBranding__desktop":"bhc_b","AdSlotBranding__mobile":"bhc_c"};